import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 bg-[#010F27] border-t border-[#29405F]" data-testid="site-footer">
      <div className="container-bl py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-heading text-lg font-bold text-white">B&L Rentals</div>
          <p className="mt-3 text-sm text-[#AEB9C9] leading-relaxed">
            Ventura County's most dependable peer-to-peer rental host. Serving Ventura County and surrounding communities since 2021.
          </p>
          <div className="mt-4 flex gap-1 items-center text-sm text-[#E5EAF2]">
            <span className="text-amber-500">★★★★★</span>
            <span className="ml-2">5.0 · 200+ trips</span>
          </div>
        </div>
        <div>
          <div className="text-sm font-semibold text-white uppercase tracking-widest">Fleet</div>
          <ul className="mt-4 space-y-2 text-sm text-[#AEB9C9]">
            <li><Link to="/vehicles/ford-transit-passenger-van" className="hover:text-[#F4C542]">Ford Transit Passenger Van</Link></li>
            <li><Link to="/vehicles" className="hover:text-[#F4C542]">View all vehicles</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-white uppercase tracking-widest">Company</div>
          <ul className="mt-4 space-y-2 text-sm text-[#AEB9C9]">
            <li><Link to="/about" className="hover:text-[#F4C542]">About us</Link></li>
            <li><Link to="/guides" className="hover:text-[#F4C542]">Rental guides</Link></li>
            <li><Link to="/faq" className="hover:text-[#F4C542]">FAQ</Link></li>
            <li><Link to="/terms" className="hover:text-[#F4C542]">Terms & cancellation</Link></li>
            <li><Link to="/insurance-requirements" className="hover:text-[#F4C542]">Insurance requirements</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-white uppercase tracking-widest">Contact</div>
          <ul className="mt-4 space-y-2 text-sm text-[#AEB9C9]">
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5" /> Oxnard, CA 93030</li>
            <li className="flex items-start gap-2"><Phone size={14} className="mt-0.5" /> <a href="tel:+18052908431" className="hover:text-[#F4C542]" data-testid="footer-phone">(805) 290-8431</a></li>
            <li className="flex items-start gap-2"><Mail size={14} className="mt-0.5" /> <a href="mailto:hello@blrental.com" className="hover:text-[#F4C542]">hello@blrental.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#29405F]">
        <div className="container-bl py-5 flex flex-col md:flex-row justify-between items-center text-xs text-[#AEB9C9]">
          <div>© {new Date().getFullYear()} B&L Rentals · Oxnard, California</div>
          <div className="mt-2 md:mt-0">Serving Ventura County · Oxnard · Ventura · Camarillo · Port Hueneme</div>
        </div>
      </div>
    </footer>
  );
}
